import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';

import { ConfigService } from '../../../../../../core';
import { ConfigPedidoTipoVendaIndicador, getTipoVendaIndicador, venda, bonificacao, amostra, consignacao, remessa, simulacao, tipoVendaOutro, } from '../config-pedido-tipo-venda-indicador';
import { ConfigPedidoTipoVendaPipe } from '../pipes';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';

@Component({
    selector: 'sgt-config-pedido-tipo-venda-multiselect',
    templateUrl: './config-pedido-tipo-venda-multiselect.component.html',
    styleUrls: ['./config-pedido-tipo-venda-multiselect.component.less'],
    providers: [
        ConfigPedidoTipoVendaPipe
    ]
})
export class ConfigPedidoTipoVendaMultiselectComponent implements OnInit {
    /** Tipos de vendas selecionados */
    @Input() tiposVendas: number[];
    /** Ao alterar a seleção dos tipos de vendas */
    @Output() tiposVendasChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() checked = 'Tipo';
    @Input() defaultTitle = 'Nenhum Tipo';
    @Input() checkedPlural = 'Tipos';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum tipo encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    constructor(private configService: ConfigService,
                private configPedidoTipoVendaPipe: ConfigPedidoTipoVendaPipe) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-config-pedido-tipo-venda ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria os tipos de vendas para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];
        this.configService.getPedido()?.tiposVenda?.forEach(tipo => {
            selects.push({
                id: tipo.tipoVenda,
                name: this.configPedidoTipoVendaPipe.transform(tipo.tipoVenda),
                classes: this.getMultiselectItemClasses(getTipoVendaIndicador(tipo.tipoVenda))
            });
        });
        this.options = selects;
    }

    /** Obtem as classes CSS para o item do multiselect do tipo de venda */
    private getMultiselectItemClasses(tipo: ConfigPedidoTipoVendaIndicador): string {
        switch (tipo) {
            case venda:
                return 'multiselect-item-config-pedido-tipo-venda multiselect-item-config-pedido-tipo-venda-venda';
            case bonificacao:
                return 'multiselect-item-config-pedido-tipo-venda multiselect-item-config-pedido-tipo-venda-bonificacao';
            case amostra:
                return 'multiselect-item-config-pedido-tipo-venda multiselect-item-config-pedido-tipo-venda-amostra';
            case consignacao:
                return 'multiselect-item-config-pedido-tipo-venda multiselect-item-config-pedido-tipo-venda-consignacao';
            case remessa:
                return 'multiselect-item-config-pedido-tipo-venda multiselect-item-config-pedido-tipo-venda-remessa';
            case simulacao:
                    return 'multiselect-item-config-pedido-tipo-venda multiselect-item-config-pedido-tipo-venda-simulacao';
            case tipoVendaOutro:
                return 'multiselect-item-config-pedido-tipo-venda multiselect-item-config-pedido-tipo-venda-outro';
            default:
                break;
        }
    }

    /** Ao alterar a seleção dos tipos de vendas */
    onChange() {
        this.tiposVendasChange.emit(this.tiposVendas);
    }
}
